module.exports = __webpack_public_path__ + "static/media/heroVector.55cddb20.svg";